import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { debounce as _debounce } from 'lodash';
import { i18nIntl, formatNumber, adaptHeightOnWidget, getRemotedbUrl, getStageName } from '../../lib/ep.js';
import { isMultiStage, stage_categories, with_score } from '../../data/bootstrap_stages';

import ActionLink from '../builder/ActionLink';
import NavigationTabs from '../builder/NavigationTabs';
import Spinner from '../builder/Spinner';
import ToggleButton from '../builder/ToggleButton';
import Tooltip from '../builder/Tooltip.js';

import InfiniteScroll from '../hoc/InfiniteScroll';

import FloatingLayerPublic from '../front/FloatingLayerPublic';
import StageFilter from '../front/StageFilter';
import UserAvatar from '../front/UserAvatar.js';

import UserParticipationsList from '../front/layers/UserParticipationsList';
import UserParticipationsUnifiedList from '../front/layers/UserParticipationsUnifiedList';

import QuizStatsPublic from '../front/quiz/QuizStatsPublic';

const RankingSlot = ({ participant, users, login_id, display_customizing_compare, display_name_as_nickname, is_builder, toggleParticipantInCompare, showParticipations }) => {
	const user = participant.User;
	const name_in_ranking = (display_name_as_nickname) ? user.name : user.first_name + ' ' + user.last_name;
	const user_in_initials = (display_name_as_nickname && false) ? { name:name_in_ranking } : user;
	const is_in_compare = (users.find((obj) => (obj.id == user.login_id)) != undefined) ? true : false;
	
	return (
		<tr class={((login_id == user.login_id) ? 'logged_user_in_ranking' : null)}>
			<td class="ranking_pos">
				<div>
					<p class="hb_secondaryFont">{(!is_builder) ? user.position : (i + 1)}.</p>
				</div>
			</td>

			<td>
				<div>
					<div class="gui_participant_avatar gui_only_wide_screen"><UserAvatar user={user_in_initials} /></div>
					<p class="gui_participant_name hb_mainFontWeightBold"><span class="gui_cutTextOnOverflow">{name_in_ranking}</span></p>
				</div>
			</td>

			<td width="25%">
				<div class="gui_flex_row_reverse">
					{(display_customizing_compare) && (
						<ToggleButton squared={true} active={!is_in_compare} _class={{icon:'ep-add-circle greenIcon', icon_off:'ep-delete-circle redIcon', other:'toggle_circled_status'}} onClick={() => toggleParticipantInCompare(user, (is_in_compare ? 'remove' : 'add'))} />
					)}

					{(!is_builder) ? (
						<ActionLink
							icon='knk-list'
							_class={{other:'view_details'}}
							onClick={() => showParticipations(user.login_id)}
						/>
					) : (
						<ActionLink
							icon='knk-list'
							_class={{other:'view_details'}}
							tooltip={<Tooltip with_icon={false} position="top">This will open a layer with the detailed participations of the user</Tooltip>}
						/>
					)}

					<p class="hb_mainFontWeightBold">{formatNumber(user.points)}</p>
				</div>
			</td>
		</tr>
	)
}

class EntriesRanking extends Component {
	constructor(props, context) {
		super(props, context);

		//Check Valid Ranking_id
		this.enabled_rankings = ((props.promotion?.stage_rankings ?? []).length > 0 || (props.promotion?.stage_rankings_global ?? false)) ? true : false;
		const global_ranking = (props.promotion?.stage_rankings_global ?? false);
		let default_ranking_id = 'all';
		if(this.enabled_rankings && !global_ranking){
			default_ranking_id = (props.promotion?.stage_rankings ?? []).filter((r) => (r.status == undefined || r.status == true))?.[0]?.id ?? 'all';
		}
		
		let multi_participation = (props.promotion?.multi_participation ?? false) == true ? true : false;
		
		this.default_filters = {
			stage_id: multi_participation && !isMultiStage(props.promotion) ? (props.stages?.[0]?.Stage?.id ?? 'all') : 'all',
			ranking_id:default_ranking_id,
			search_value:"",
		};

		this.state = {
			custom_layer_back_button:false,
			custom_layer_title:false,
			display_participations:false,
			filters:this.default_filters,
			loaded:false,
			loading_multistage_data:false,
			loaded_participants:{},
			max_score_in_stage:0,
			participants:[],
			participation:false,
			participation_multistage:false,
			quiz_answers:false,
			selected_tab:false,
			total:(props.total != undefined) ? props.total : 0,
			tabs:[],
			users:[],
		}

		this.span = 2;
		this.total_in_top = (props.total_in_top != undefined) ? props.total_in_top : 10;

		this.max_stages_to_filter = 5;	// + global + combined

		this.is_builder = (props.is_builder != undefined) ? props.is_builder : false;
		this.scrollable_element = window.document;
		this.onChangeDebounced = _debounce(this.onChangeDebounced, 1000);

		this.is_multistage = (props.promotion.is_multistage != undefined) ? props.promotion.is_multistage : false;
		
	}

	componentDidMount() {
		this.fetchParticipants(1, (d) => this.fetched(d.data));
		this.setState({ ...this.state });
		adaptHeightOnWidget();
	}

	getRankingUrl() {
		const promotion = this.props.promotion;
		const filter_stage_id = this.state.filters.stage_id;
		let filter_ranking_id = this.state.filters.ranking_id;
		const rankings = (promotion?.stage_rankings ?? []);
		let search_correct = rankings.find((r) => r.id == filter_ranking_id);
		if(!search_correct)filter_ranking_id = 'all';
		if(this.enabled_rankings && filter_ranking_id == 'all'){
			const global_ranking = (promotion?.stage_rankings_global ?? false);
			if(!global_ranking)filter_ranking_id = rankings[0].id
		}

		var url = `/users/ranking/${this.props.promotion.id}`;
		if(!this.enabled_rankings && filter_stage_id != 'all') {
			url += `/${filter_stage_id}`;
		}else if(this.enabled_rankings && filter_ranking_id != 'all') {
			url += `/${filter_ranking_id}`;
		}
		return url;
	}

	fetched(data) {

		if (this.state.filters.stage_id != undefined) {
			this.state.loaded_participants[this.state.filters.stage_id] = data;
		}

		this.parseHash();
		this.state.participants = this.state.participants.concat(data);
		this.filter();
		if(!this.state.loaded) this.state.loaded = true;

		this.processRanking();
		this.setState({ ...this.state });
	}

	processRanking() {
		if((this.state.filters.search_value != undefined && this.state.filters.search_value != "") || this.state.users.length > 0) {
			return [this.state.participants.slice(0,this.total_in_top),[]];
		}

		const span = this.span;
		const current = this.state.participants.find(u=>u.User.login_id == this.props.login_id);
		const position = current != undefined ? parseInt(current.User.position): 0;

		this.state.user_pos = position;

		if (position < this.total_in_top) return [this.state.participants.slice(0,this.total_in_top),[]];

		let top = [];

		let ranking = this.state.participants.filter((user) => {
			const upos = parseInt(user.User.position);

			if ( upos <= this.total_in_top) top.push(user);

			if(upos <= this.total_in_top || (upos < (position - span)) || (upos > (position + span))) return null;
			return user;
		});
		
		const data = [
			top,
			ranking,
		];

		return data;
	}

	fetchParticipants(page, cb) {
		var d = {};
		if(page) d.page = page;
		var search = (this.state.filters.search_value != '') ? this.state.filters.search_value : false;
		if(search) d.search = search;
		if(!this.is_builder) {
			$.get(getRemotedbUrl(this.getRankingUrl()), d, (result) => {
				var has_more = false;
				d.page = -1;
				if(result.entries != undefined) {
					has_more = (result.entries.length > 0) ? true : false;
				}
				this.setState({loaded:true,earching:false, total:result.total });
				if(cb) cb({ data:result.entries, hasMore:has_more });
			}, 'JSON');
		} else {
			this.setState({ loaded:true, searching:false, total:this.props.participants.length });
			cb({ data:this.props.participants.sort((a, b) => (a.User.points < b.User.points ? 1 : -1)), hasMore:false });
		}
	}

	toggleParticipations() {
		this.state.display_participations = !this.state.display_participations;
		if(!this.state.display_participations) {
			this.state.participation = false;
			this.state.participation_multistage = false;
		}
		this.setState({ ...this.state });
	}

	search(k, v) {
		if(this.state.filters == undefined) this.state.filters = this.default_filters;
		this.state.filters[k] = v;

		const stage_changed = k == 'stage_id';
		const is_searching = k == 'search_value';

		const promotion = this.props.promotion;
		let load_participants = false;

		if(stage_changed) {
			if(!this.state.tabs.find(t=>t.id == this.state.filters.stage_id)) {
				const st = this.props.stages.find(s=>s.Stage.id==this.state.filters.stage_id);

				if(st) {
					this.state.tabs.push({id:st.Stage.id, name:this.stageName(st)});
					this.generateHash();
				}
				if(this.state.loaded_participants[this.state.filters.stage_id] != undefined)load_participants=true;
			}
		}

		if(load_participants){
			this.filter();
			this.setState({
				participants:this.state.participants,
				loaded:true,
			});
			return;
		}


		if(is_searching || (stage_changed && load_participants)) {
			if(this.state.loaded_participants[this.state.filters.stage_id].length == 5000) {
				$.get(getRemotedbUrl(this.getRankingUrl()), {p:-1} ,(result) => {
					this.state.loaded_participants[this.state.filters.stage_id] = result.entries;
					this.filter();
					this.setState({ participants:this.state.participants });
				}, 'JSON');
				return;
			}
			this.filter();
			this.setState({ participants:this.state.participants });
			return;
		}

		this.setState({ loaded:false, filters:{...this.state.filters} });
		this.onChangeDebounced();
	}

	filter () {
		const users = this.state.users.map((u) => (u.id)).join("|");

		this.state.participants = (this.state.loaded_participants?.[this.state.filters.stage_id] ?? []).filter((p) => {
			if(this.state.filters.search_value != "") {
				const regex = new RegExp(this.state.filters.search_value, 'i');
				if(!p.User.name.match(regex)) return false;
			} else {
				if(this.state.users.length > 0) {
					const regex = new RegExp(`^(${users})$`);
					if(!p.User.login_id.match(regex)) return false;
				}
			}

			return true;
		});
	}

	generateHash() {
		if(this.is_builder) return false;

		let hash = "";
		let harray = []
		if(this.state.tabs.length > 0) harray.push(`s:${this.state.tabs.map((t) => t.id).join("|")}`);
		if(this.state.users.length > 0) harray.push(`u:${this.state.users.map((t) => t.id).join("|")}`);

		hash = harray.join(",");
		window.location.hash = hash;
	}

	parseHash() {

		const promotion = this.props.promotion;
		let harray = window.location.hash.replace("#", "").split(",");
		let filters = {}
		harray.map(filter => {
			let data = filter.split(':');

			switch(data[0]) {
				case 's':
					filters.stages = data[1].split('|');
					break;

				case 'u':
					filters.users = data[1].split('|');
					break;
			}
		});

		
		if(filters.stages != undefined) {
			const rankings = (promotion.stage_rankings ?? []);
			if(rankings.length > 0 && this.state.filters.ranking_id == 'all'){//estem filtrant sobre un stage ja passat per url
				(promotion.stage_rankings ?? []).map((ranking,i) => {
					if(JSON.stringify(ranking.stages.sort()) === JSON.stringify(filters.stages.sort())){
						this.state.filters.ranking_id = ranking.id;
						this.setState({...this.state});
					}
				})
			}

			const filtered = this.props.stages.filter((st) => (
				filters.stages.includes(st.Stage.id))
			);

			const only_one_stage = (filtered.length == 1) ? true : false;
			const only_combined = rankings.length > 0 && this.state.filters.ranking_id != 'all' ? true : false;

			const loadParticipants = (st) => {
				return new Promise((resolve) => {
					if (this.state.loaded_participants[st.Stage.id] === undefined) {
						$.get(getRemotedbUrl(`/users/ranking/${this.props.promotion.id}/${st.Stage.id}`), (result) => {
							this.state.loaded_participants[st.Stage.id] = result.entries;
							resolve(); // Resolvemos la promesa cuando la petición termina
						}, 'JSON');
					} else {
						resolve(); // Si ya está cargado, resolvemos de inmediato
					}
				});
			};

			Promise.all(filtered.map((st) => loadParticipants(st))).then(() => {
				if (only_one_stage && !only_combined) {
					this.selectTab(filtered[0].Stage.id);
				}else if(only_combined){
					this.selectTab('combined');
				}
			});

			this.state.tabs = filtered.map((st) => ({
				id: st.Stage.id,
				name: this.stageName(st)
			}));

		}

		if (filters.users != undefined) {
			this.state.users = this.state.loaded_participants['all'].filter((user) => (filters.users.includes(user.User.login_id))).map((user) => (
				{ id:user.User.login_id, name:user.User.name}
			));
		}
		this.setState({...this.state});
	}

	computePartial() {
		//if (this)
	}

	showParticipations(login_id) {
		if(!this.state.display_participations && !this.is_builder) {
			const allowed_entry_summary = (this.is_multistage && (this.state.filters.stage_id == 'all' && !this.enabled_rankings || this.enabled_rankings && this.state.filters.ranking_id == 'all')) ? true : false;
			if(allowed_entry_summary) {
				this.setState({ loading_multistage_data:true });
				$.get(getRemotedbUrl(`/users/entry_summary/${this.props.promotion.id}/?id=${login_id}`), (result) => {
					if(result.summary != undefined && result.summary.length > 0) {
						result.from = result.summary[0].StageScore.data;
						this.state.participation_multistage = result;
						this.setState({ loading_multistage_data:false });
						this.toggleParticipations();
					}
				}, 'JSON');
			} else {
				var url = `/users/participations_ranking/${this.props.promotion.id}`;
				if(this.state.filters.stage_id == 'combined') url += `/${(window.location.hash).replace('#s:','')}`;
				else if(this.state.filters.stage_id != 'all') url += `/${this.state.filters.stage_id}`;
				else if(this.state.filters.ranking_id != 'all'){
					const rankings = (this.props.promotion?.stage_rankings ?? []);
					let search_correct = rankings.find((r) => r.id == this.state.filters.ranking_id);
					if(search_correct)url += `/${((search_correct?.stages ?? []).join('|'))}`;
				}

				$.post(getRemotedbUrl(url), { login:login_id }, (result) => {
					if(result.status) {
						delete result.status;
						this.state.participation = result;
						this.setState({ ...this.state });
						this.toggleParticipations();
					}
				}, 'JSON');
			}
		}
	}

	stageName(stage) {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);
		return getStageName(stage?.Stage, i18n);
	}

	showQuiz = (user_id) => {
		this.setState({quiz_answers:user_id});
	}

	onChangeDebounced() {
		this.setState({ participants:[] });
		this.fetchParticipants(1, (d) => this.fetched(d.data));
	}

	on_view_detail(custom_title, back_button) {
		this.setState({ custom_layer_title:custom_title, custom_layer_back_button:back_button });
	}

	selectTab = (stage_id) => {
		this.state.filters.stage_id = stage_id;

		if(stage_id == 'combined') {
			this.calculateCombined();
		}

		this.filter();
		this.setState({
			filters:{...this.state.filters},
			selected_tab:stage_id,
		});
	}

	removeTab = (stage_id) => {
		this.state.filters.stage_id = 'all';
		this.filter();
		this.state.tabs = this.state.tabs.filter((t) => (t.id != stage_id))
		this.setState({
			selected_tab:false,
			tabs:[...this.state.tabs],
		});

		this.generateHash();
	}

	calculateCombined = () => {
		let combined = {};

		for(var index in this.state.tabs) {
			//if(i == 'all' || i =='combined') continue;
			let i = this.state.tabs[index].id;

			for(var j in this.state.loaded_participants[i]) {
				const user = this.state.loaded_participants[i][j];

				if(combined[user.User.login_id] == undefined) {
					user.User.points = parseFloat(user.User.points);
					combined[user.User.login_id] = { User:{...user.User} };
				} else {
					combined[user.User.login_id].User.points+= parseFloat(user.User.points);
				}
			}
		}

		let data = Object.values(combined).sort((a,b)=>(parseFloat(a.User.points) > parseFloat(b.User.points) ? -1 : 1));

		for(var k in data) {
			data[k].User.position = parseInt(k) + 1;
		}

		this.state.loaded_participants['combined'] = data;
	}

	addUser = (user) => {
		if(this.props.login_id != undefined &&  this.props.login_id != "" && user.login_id != this.props.login_id && this.state.users.length == 0) {
			const me = this.state.loaded_participants['all'].find((u) => u.User.login_id == this.props.login_id);
			this.state.users.push({id:me.User.login_id, name:me.User.name});
		}

		this.state.users.push({id:user.login_id, name:user.name});
		this.state.filters.search_value = "";
		this.filter();
		this.generateHash();
		this.setState({...this.state});
	}

	removeUser = (user) => {
		this.state.users = this.state.users.filter((u) => u.id != user.login_id);
		this.filter();
		this.setState({users:this.state.users});
		this.generateHash();
	}

	toggleParticipantInCompare = (user, action) => {
		if(action == 'remove') {
			this.removeUser(user);
		} else {
			this.addUser(user);
		}
	}

	render() {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);

		const [ top, ranking ] = this.processRanking(this.state.participants);
		const promotion = this.props.promotion;
		const rankings = promotion?.stage_rankings ?? [];
		const ranking_global = promotion?.stage_rankings_global ?? false;
		const custom_ranking = rankings.length == 0 && !ranking_global ? false :  true;
		const participants = (this.state.users.length > 0) ? this.state.participants : top;

		const stages = this.props.stages.filter((stage) => {
			return with_score(stage.Stage.promotion_type_id);
		});;

		let eval_stage = stages[0]?.Stage;
		if(this.state.selected_tab && this.state.selected_tab != 'combined'){
			const selected_stage_by_tab = this.props.stages.find((st) => {return this.state.selected_tab == st.Stage.id});
			if(selected_stage_by_tab)eval_stage = selected_stage_by_tab.Stage;
		}

		const is_quiz = (stages.length > 0 && (eval_stage.type == stage_categories.ID_QUIZ_CATEGORY.id || eval_stage.type == stage_categories.ID_TIMED_CATEGORY.id)) ? true : false;
		const is_team = eval_stage?.is_team ?? false;
		const is_form = (stages.length > 0 && (eval_stage.type == stage_categories.ID_FORM_CATEGORY.id || eval_stage.type == stage_categories.ID_FORM_CATEGORY.id)) ? true : false;

		const public_quiz = (this.props.promotion.config.quiz_public != undefined && (this.props.promotion.config.quiz_public == 'true' || this.props.promotion.config.quiz_public == true));

		const has_public_quiz_stats = (stages.length > 0) ? (eval_stage.quiz_answers_in_ranking != undefined && eval_stage.quiz_answers_in_ranking == 'true') : public_quiz;

		const display_customizing_compare = (!custom_ranking && (this.state.filters.search_value != undefined && this.state.filters.search_value != "" || this.state.users.length > 0)) ? true : false;

		const display_name_as_nickname = this.props?.promotion?.need_nickname ?? false;


		let sections = [{
			label:i18n("Overall"),
			onClick:() => this.selectTab('all'),
			selected:(this.state.filters.stage_id == 'all') ? true : false,
			tab_class:'is_global',
		}];
		this.state.tabs.map((tab, i) => {
			sections.push({
				label:tab.name,
				onClick:() => this.selectTab(tab.id),
				onRemoveTab:() => this.removeTab(tab.id),
				removable:true,
				selected:(this.state.filters.stage_id == tab.id) ? true : false,
				tab_class:`is_tab_${(i + 1)}`,
			});
		});

		if(this.state.tabs.length > 1) {
			sections.push({
				label:i18n("Combined"),
				onClick:() => this.selectTab('combined'),
				selected:(this.state.filters.stage_id == 'combined') ? true : false,
				tab_class:'is_combined',
			});
		}

		const display_separator = (top.length == 0 || ranking.length == 0 || (parseInt(top[top.length - 1].User.position) == parseInt(ranking[0].User.position) - 1)) ? false : true;

		const selectedStages = stages.map((st) => {
			st.Stage.selected = false;
			for(var i in this.state.tabs) {
				if(this.state.tabs[i].id == st.Stage.id) {
					st.Stage.selected = true;
					return st;
				}
			}
			return st;
		})

		const has_link_to_login = (participants.length > 0 && (this.props.login_id == undefined || this.props.login_id == "")) ? true : false;
		const min_height_section = (has_link_to_login) ? 425 : 480;
		const allowed_complete_summary = (this.is_multistage && (this.state.filters.stage_id == 'all' && !this.enabled_rankings || this.enabled_rankings && this.state.filters.ranking_id == 'all')) ? true : false;
		const allowed_filtered_summary = (!this.is_multistage || this.state.filters.stage_id != 'all' || this.state.filters.ranking_id != 'all') ? true : false;
		return (
			<div class="gui_ranking">
				<StageFilter
					onChange={this.search.bind(this)}
					search_value={this.state.filters.search_value}
					locale={this.props.locale}
					promotion={this.props.promotion}
					stages={selectedStages}
					stage_id={this.state.filters.stage_id}
					ranking_id={this.state.filters.ranking_id}
					is_builder={this.is_builder}
					disable_stage_filter={(sections.length >= this.max_stages_to_filter + 2) ? true : false}
				/>

				{(stages.length > 1 && !custom_ranking) && (
					<nav class="nice_tabs_selector ranking_tabs_filter">
						<NavigationTabs
							add_dom_separators={true}
							sections={sections}
							in_frontend={true}
							display_type='tab'
							_class={{ other:'not_in_builder' }}
						/>
					</nav>
				)}

				<div>
					{(!this.state.loaded) ? (
						<div class="is_loading_contents" style={{height:'200px'}}>
							<Spinner>Loading scores</Spinner>
						</div>
					) : (
						<div class="gui_not_in_top_big">
							{((participants.length) > 0) ? (
								<InfiniteScroll
									fetch={(p, cb) => this.fetchParticipants(p, cb)}
									fetched={this.fetched.bind(this)}
									_maxHeight={{ minHeight:`${min_height_section}px` }}
									scroll_on_document={false}
									no_ep={true}
								>
									<table cellSpacing="0" cellPadding="0" style={{width:'100%'}}>
										<thead>
											{(this.state.users.length < 1) ? (
												<tr>
													<th class="hb_secondaryFont" colSpan={2} style={{ '--text-default-align':'start'}}>
														<FormattedMessage id="Top {number}" values={{number:this.total_in_top}} />

														{(this.state.user_pos != undefined && this.state.user_pos > 0) && (
															<span>
																<span class="gui_not_in_start_tiny gui_not_in_end_tiny">-</span>{i18n("Your position")}: {this.state.user_pos}
															</span>
														)}
													</th>

													<th class="hb_secondaryFont gui_text_align_end" width="25%">{i18n("Score")}</th>
												</tr>
											) : (
												<tr>
													<th class="hb_secondaryFont">{i18n("Position")}</th>

													<th class="hb_secondaryFont">{i18n("Participant")}</th>

													<th class="hb_secondaryFont gui_text_align_end" width="25%">{i18n("Score")}</th>
												</tr>
											)}
										</thead>

										<tbody>
											{participants.map((participant, i) => {
												return (
													<RankingSlot
														key={'user' + participant.User.login_id}
														participant={participant}
														users={this.state.users}
														login_id={this.props.login_id}
														display_customizing_compare={display_customizing_compare}
														display_name_as_nickname={display_name_as_nickname}
														is_builder={this.is_builder}
														showParticipations={this.showParticipations.bind(this)}
														toggleParticipantInCompare={this.toggleParticipantInCompare.bind(this)}
													/>
												)
											})}

											{(display_separator) && (
												<tr><td colSpan={3}>...</td></tr>
											)}

											{ranking.length > 0 && ranking.map((participant) => {
												return (
													<RankingSlot
														key={`r_${participant.User.login_id}`}
														participant={participant}
														users={this.state.users}
														login_id={this.props.login_id}
														display_customizing_compare={display_customizing_compare}
														display_name_as_nickname={display_name_as_nickname}
														is_builder={this.is_builder}
														showParticipations={this.showParticipations.bind(this)}
														toggleParticipantInCompare={this.toggleParticipantInCompare.bind(this)}
													/>
												)
											})}
										</tbody>
									</table>
								</InfiniteScroll>
							) : (
								<p>{i18n("There are no participants")}</p>
							)}

							{(has_link_to_login) && (
								<div class="login_to_check">
									<span class="icon knk-annonymous-users" />

									<p>{i18n("Already a participant?")}</p>

									<ActionLink
										_href={`/login/${this.props.promotion.id}`}
									>Sign in and check out your position</ActionLink>
								</div>
							)}
						</div>
					)}
				</div>

				{(this.state.quiz_answers != false) && (
					<FloatingLayerPublic
						pm={this.props.promotion}
						title="test"
						backButton={() => this.setState({ quiz_answers:false })}
					>
						<QuizStatsPublic
							promotion_id={this.props.promotion.id}
							user_id={this.state.quiz_answers}
						/>
					</FloatingLayerPublic>
				)}

				{/*
				TO DO: PUBLIC GUESS SCORE STATS IN RANKING
				(true) && (
					<FloatingLayerPublic
						pm={this.props.promotion}
						title="test"
						backButton={() => this.setState({ quiz_answers:false })}
					>
						<GuessScoreResumeWithPoints
							promotion_id={this.props.promotion.id}
							user_id={this.state.quiz_answers}
						/>
					</FloatingLayerPublic>
				)*/}

				{(this.state.display_participations && this.state.participation_multistage && allowed_complete_summary) && (
					<FloatingLayerPublic
						pm={this.props.promotion}
						custom_back_button={this.state.custom_layer_back_button}
						title={`<h1>${this.state.participation_multistage.from}</h1>`}
						backButton={() => this.toggleParticipations()}
					>
						<UserParticipationsUnifiedList
							stage_participations={this.state.participation_multistage}
							stages={this.props.stages}
							promotion={this.props.promotion}
							has_quiz_stages={true}
							user_name={this.state.participation_multistage.from}
						/>
					</FloatingLayerPublic>
				)}

				{(this.state.display_participations && this.state.participation && allowed_filtered_summary) && (
					<FloatingLayerPublic
						pm={this.props.promotion}
						custom_back_button={this.state.custom_layer_back_button}
						title={`<h1>${this.state.participation.from}</h1><p>${(this.state.custom_layer_title !== false) ? this.state.custom_layer_title : this.props.intl.formatMessage({ id:"{total} participations" }, { total:this.state.participation.participations.length })}</p>`}
						backButton={() => this.toggleParticipations()}
					>
						<UserParticipationsList
							participations={this.state.participation.participations}
							is_game={true}
							is_quiz={is_quiz && has_public_quiz_stats}
							is_team={is_team}
							on_view_detail={this.on_view_detail.bind(this)}
							promotion={this.props.promotion}
							stages={this.props.stages}
							username={this.state.participation.from}
							stage = {this.props.stages.find(s=>s.Stage.id == this.state?.filters?.stage_id ?? 'all')}
							in_layer={true}
						/>
					</FloatingLayerPublic>
				)}
			</div>
		);
	}
}

export default injectIntl(EntriesRanking);